import React from "react";

import icon from "./icon.png";

function ColorPickerIcon({ className }: { className: string }) {
  return <img className={className} src={icon} />;
}

export { ColorPickerIcon };
